/// <amd-module name="Wit/UI/WorkItemViewProvider" />
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { BaseProviderComponent, WorkItemId } from "Wit/UI/Data";
import { IWorkItemViewProviderProps } from "./WorkItemViewProvider.Props";

export interface IWorkItemViewProviderState {
    workItem: WorkItem | null;
}

export class WorkItemViewProvider extends BaseProviderComponent<IWorkItemViewProviderProps, IWorkItemViewProviderState> {

    constructor(props: IWorkItemViewProviderProps) {
        super(props);

        const workItemInput = this._getWorkItem(this.props.dataSource);

        if (workItemInput instanceof Promise) {
            workItemInput.then((workItem) => {
                if (this.componentMounted()) {
                    this.setState({ workItem: workItem });
                }
            }, () => { /* No op if rejected */ });
        }

        this.state = { workItem: null };
    }

    public render(): JSX.Element | null {
        const { workItem } = this.state
        if (!workItem) {
            // Render nothing if work item data is not yet ready.
            return null;
        }

        const { children } = this.props;
        return children ? children(workItem) : null;
    }

    private _getWorkItem(dataSource: WorkItemId): Promise<WorkItem | null> | null {
        if (!dataSource) {
            return null;
        }
        return this.props.dataProvider.getWorkItem(dataSource);
    }
}
